import { render } from "./OwnerTemporaryActions.vue?vue&type=template&id=59c49e9c"
import script from "./OwnerTemporaryActions.vue?vue&type=script&lang=js"
export * from "./OwnerTemporaryActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__